import { DatabaseReference, ref } from "firebase/database";
import { Target } from "../../models/Keyword";
import { database } from "../../utils/firebase";
import { ModelName } from "../../models/ModelName";

export abstract class SearchRepository {
    protected realDbRef: DatabaseReference;
    constructor() {
        this.realDbRef = ref(database, "index");
    }
    abstract find(query: string, model?: ModelName, count?: number): Promise<Target[]>;
}
